export type Language = "en" | "ro" | "sr" | "mk" | "bg" | "hu";

export const languageNames: Record<Language, string> = {
  en: "English",
  ro: "Română",
  sr: "Српски",
  mk: "Македонски",
  bg: "Български",
  hu: "Magyar",
};

export const languageFlags: Record<Language, string> = {
  en: "🇬🇧",
  ro: "🇷🇴",
  sr: "🇷🇸",
  mk: "🇲🇰",
  bg: "🇧🇬",
  hu: "🇭🇺",
};

type TranslationKeys = {
  nav_services: string;
  nav_howItWorks: string;
  nav_pricing: string;
  nav_testimonials: string;
  nav_getStarted: string;

  hero_badge: string;
  hero_title: string;
  hero_subtitle: string;
  hero_cta: string;
  hero_secondary: string;
  hero_countries: string;
  hero_families: string;
  hero_caregivers: string;
  hero_book_service: string;

  services_label: string;
  services_title: string;
  services_subtitle: string;
  service_errands: string;
  service_errands_desc: string;
  service_cooking: string;
  service_cooking_desc: string;
  service_cleaning: string;
  service_cleaning_desc: string;
  service_walks: string;
  service_walks_desc: string;
  service_pharmacy: string;
  service_pharmacy_desc: string;
  service_social: string;
  service_social_desc: string;
  service_book_cta: string;

  how_label: string;
  how_title: string;
  how_subtitle: string;
  how_step1_title: string;
  how_step1_desc: string;
  how_step2_title: string;
  how_step2_desc: string;
  how_step3_title: string;
  how_step3_desc: string;

  pricing_label: string;
  pricing_title: string;
  pricing_subtitle: string;
  pricing_mostPopular: string;
  pricing_perMonth: string;
  pricing_getStarted: string;
  pricing_essential: string;
  pricing_essential_desc: string;
  pricing_comfort: string;
  pricing_comfort_desc: string;
  pricing_premium: string;
  pricing_premium_desc: string;
  pricing_feature_2visits: string;
  pricing_feature_errands: string;
  pricing_feature_housekeeping: string;
  pricing_feature_weeklyPhotos: string;
  pricing_feature_phoneSupport: string;
  pricing_feature_5visits: string;
  pricing_feature_allEssential: string;
  pricing_feature_meals: string;
  pricing_feature_pharmacy: string;
  pricing_feature_dailyPhotos: string;
  pricing_feature_dedicatedCaregiver: string;
  pricing_feature_dailyVisits: string;
  pricing_feature_allComfort: string;
  pricing_feature_walks: string;
  pricing_feature_doctorVisit: string;
  pricing_feature_realtime: string;
  pricing_feature_emergency: string;
  pricing_feature_videoReport: string;

  testimonials_label: string;
  testimonials_title: string;

  story_label: string;
  story_title: string;
  story_p1: string;
  story_p2: string;
  story_p3: string;
  story_card1_title: string;
  story_card1_desc: string;
  story_card2_title: string;
  story_card2_desc: string;
  story_card3_title: string;
  story_card3_desc: string;

  cta_title: string;
  cta_subtitle: string;
  cta_primary: string;
  cta_secondary: string;

  footer_desc: string;
  footer_services: string;
  footer_countries: string;
  footer_contact: string;
  footer_rights: string;

  order_title: string;
  order_subtitle: string;
  order_select_plan: string;
  order_reserve_cta: string;
  order_reserve_note: string;
  order_contact_cta: string;
  order_back: string;
  order_success_title: string;
  order_success_desc: string;
  order_processing: string;
  order_your_details: string;
  order_name: string;
  order_name_placeholder: string;
  order_email: string;
  order_email_placeholder: string;
  order_phone: string;
  order_phone_placeholder: string;
  order_fill_fields: string;
  order_interest_cta: string;
  order_interest_note: string;
  order_interest_success: string;
  order_interest_success_desc: string;
  order_message: string;
  order_message_placeholder: string;
  order_sending: string;
  order_market_badge: string;
  order_step_plan: string;
  order_step_parent: string;
  order_step_needs: string;
  order_step_contact: string;
  order_parent_section: string;
  order_parent_name: string;
  order_parent_name_placeholder: string;
  order_parent_age: string;
  order_parent_age_60_69: string;
  order_parent_age_70_79: string;
  order_parent_age_80_89: string;
  order_parent_age_90_plus: string;
  order_parent_country: string;
  order_parent_city: string;
  order_parent_city_placeholder: string;
  order_living_situation: string;
  order_living_alone: string;
  order_living_spouse: string;
  order_living_family: string;
  order_living_care_home: string;
  order_needs_section: string;
  order_needs_hint: string;
  order_need_companionship: string;
  order_need_meals: string;
  order_need_medication: string;
  order_need_mobility: string;
  order_need_hygiene: string;
  order_need_housekeeping: string;
  order_need_appointments: string;
  order_need_other: string;
  order_needs_other_placeholder: string;
  order_timeline: string;
  order_timeline_asap: string;
  order_timeline_1_3_months: string;
  order_timeline_exploring: string;
  order_preferred_contact: string;
  order_contact_method_email: string;
  order_contact_method_phone: string;
  order_contact_method_whatsapp: string;
  order_country_serbia: string;
  order_country_romania: string;
  order_country_north_macedonia: string;
  order_country_bulgaria: string;
  order_country_hungary: string;
  order_country_other: string;
  order_fill_plan: string;
  order_fill_needs: string;
  order_fill_phone: string;
  order_fill_country: string;

  dynamic_not_found: string;

  faq_title: string;
  faq_q1: string;
  faq_a1: string;
  faq_q2: string;
  faq_a2: string;
  faq_q3: string;
  faq_a3: string;
  faq_q4: string;
  faq_a4: string;
  faq_q5: string;
  faq_a5: string;
  faq_q6: string;
  faq_a6: string;
  faq_q7: string;
  faq_a7: string;
  faq_q8: string;
  faq_a8: string;
};

export type StoryVariant = "roma" | "universal";

type VariantTranslations = Record<StoryVariant, TranslationKeys>;

// ─── ENGLISH ────────────────────────────────────────────────────────────────

const en_shared: TranslationKeys = {
  nav_services: "Services",
  nav_howItWorks: "How It Works",
  nav_pricing: "Pricing",
  nav_testimonials: "Testimonials",
  nav_getStarted: "Get Started",

  hero_badge: "Trusted home care across 5 countries",
  hero_title: "Family is everything. We care for yours like our own.",
  hero_subtitle: "Warm, dependable home care for your parents in Serbia, Romania, Macedonia, Bulgaria & Hungary while you're abroad.",
  hero_cta: "Start Caring Today",
  hero_secondary: "See How It Works",
  hero_countries: "5 Countries",
  hero_families: "500+ Families United",
  hero_caregivers: "Vetted Caregivers",
  hero_book_service: "Book a Service",

  services_label: "What We Do",
  services_title: "The warmth of community, right at their door",
  services_subtitle: "Our caregivers bring practical help and genuine kindness that keeps your parents happy and independent at home.",
  service_errands: "Errands & Shopping",
  service_errands_desc: "Grocery runs, post office visits, bill payments — all the daily errands handled with care.",
  service_cooking: "Cooking & Meals",
  service_cooking_desc: "Home-cooked traditional meals prepared fresh, respecting dietary needs and preferences.",
  service_cleaning: "Cleaning & Tidying",
  service_cleaning_desc: "Regular housekeeping to keep their home clean, comfortable, and safe.",
  service_walks: "Walks & Companionship",
  service_walks_desc: "Daily walks, social visits, and meaningful conversation to brighten their day.",
  service_pharmacy: "Pharmacy & Health",
  service_pharmacy_desc: "Prescription pickups, medication reminders, and accompanying to doctor visits.",
  service_social: "Social Support",
  service_social_desc: "Help with phone calls, technology, and staying connected with family and friends.",
  service_book_cta: "Book This Service",

  how_label: "How It Works",
  how_title: "Simple steps to honor your family",
  how_subtitle: "Distance shouldn't break the bond. In minutes, you can bring caring hands to your parents' home — managed from your phone, wherever life took you.",
  how_step1_title: "Tell Us About Your Parents",
  how_step1_desc: "Share their location, needs, and preferences. We'll match them with the right caregiver nearby.",
  how_step2_title: "Choose a Care Plan",
  how_step2_desc: "Select from flexible plans — weekly visits, daily check-ins, or custom schedules that fit your family.",
  how_step3_title: "Care Begins, You Stay Updated",
  how_step3_desc: "Your parents receive compassionate help at home. Get regular updates, photos, and peace of mind.",

  pricing_label: "Pricing",
  pricing_title: "Transparent, affordable care plans",
  pricing_subtitle: "No hidden fees. Cancel anytime. All plans include vetted, background-checked caregivers.",
  pricing_mostPopular: "Most Popular",
  pricing_perMonth: "/month",
  pricing_getStarted: "Get Started",
  pricing_essential: "Essential",
  pricing_essential_desc: "Light support for independent parents",
  pricing_comfort: "Comfort",
  pricing_comfort_desc: "Comprehensive daily care and companionship",
  pricing_premium: "Premium",
  pricing_premium_desc: "Full daily support and priority care",
  pricing_feature_2visits: "2 visits per week",
  pricing_feature_errands: "Errands & grocery shopping",
  pricing_feature_housekeeping: "Basic housekeeping",
  pricing_feature_weeklyPhotos: "Weekly photo updates",
  pricing_feature_phoneSupport: "Phone support",
  pricing_feature_5visits: "5 visits per week",
  pricing_feature_allEssential: "All Essential services",
  pricing_feature_meals: "Home-cooked meals",
  pricing_feature_pharmacy: "Pharmacy & health support",
  pricing_feature_dailyPhotos: "Daily updates with photos",
  pricing_feature_dedicatedCaregiver: "Dedicated caregiver",
  pricing_feature_dailyVisits: "Daily visits (7 days)",
  pricing_feature_allComfort: "All Comfort services",
  pricing_feature_walks: "Companionship walks",
  pricing_feature_doctorVisit: "Doctor visit accompaniment",
  pricing_feature_realtime: "Real-time updates",
  pricing_feature_emergency: "24/7 emergency line",
  pricing_feature_videoReport: "Monthly video call report",

  testimonials_label: "Testimonials",
  testimonials_title: "Our family keeps growing",

  story_label: "Our Story",
  story_title: "Built by those who care first",
  story_p1: "Vita Dom was born from something personal. Our founders — professionals living across Europe — faced the same quiet worry every day: who is looking after our parents back home?",
  story_p2: "For us, abandoning your elders is unthinkable. Family is the foundation of everything. So rather than accept the distance, our founders began organizing care for their own parents — cooking, errands, companionship, pharmacy runs — through trusted local helpers.",
  story_p3: "What started as a family practice quickly became a mission. Vita Dom was created to extend this care to every family facing the same struggle — because no parent should feel forgotten.",
  story_card1_title: "Family First, Always",
  story_card1_desc: "Every decision we make starts with one question: would this be good enough for our own parents?",
  story_card2_title: "Community Values, European Reach",
  story_card2_desc: "We bring community-rooted kindness to families across five countries.",
  story_card3_title: "From Personal to Universal",
  story_card3_desc: "What began as founders caring for their own parents is now a service open to every diaspora family who refuses to let distance win.",

  cta_title: "Your parents gave you everything. Now give back.",
  cta_subtitle: "We never abandon our elders. Join hundreds of families keeping that promise across Europe. Your first consultation is free.",
  cta_primary: "Start Free Consultation",
  cta_secondary: "Call Us",

  footer_desc: "Compassionate home care across the Balkans and Central Europe — rooted in family values and kindness.",
  footer_services: "Services",
  footer_countries: "Countries",
  footer_contact: "Contact",
  footer_rights: "Vita Dom. All rights reserved.",

  order_title: "Tell us about your parent's care needs",
  order_subtitle: "Help us understand what your family needs — no payment, no commitment. We'll review your answers and contact you within 1–2 business days.",
  order_market_badge: "Market research · Free · No payment required",
  order_select_plan: "Which care plan interests you?",
  order_reserve_cta: "Request to book",
  order_reserve_note: "Reserve your place — no payment needed now. We'll call you within 1–2 business days to complete your registration.",
  order_contact_cta: "Prefer to talk directly?",
  order_back: "Back to home",
  order_success_title: "Thank you!",
  order_success_desc: "We've received your request. A colleague will contact you within 1–2 business days.",
  order_processing: "Processing...",
  order_your_details: "Your contact details",
  order_name: "Your full name",
  order_name_placeholder: "e.g. Maria Popescu",
  order_email: "Your email",
  order_email_placeholder: "your@email.com",
  order_phone: "Your phone number",
  order_phone_placeholder: "+40 712 345 678",
  order_fill_fields: "Please fill in your name and email.",
  order_fill_plan: "Please select a care plan.",
  order_fill_needs: "Please select at least one type of help needed.",
  order_fill_phone: "Please add a phone number so we can reach you.",
  order_fill_country: "Please select the country where your parent lives.",
  order_interest_cta: "Submit my request",
  order_interest_note: "We'll use this information only to understand demand and follow up with you. No payment is required.",
  order_interest_success: "Thank you — we received your request!",
  order_interest_success_desc: "Our team will review your parent's care needs and contact you within 1–2 business days.",
  order_message: "Anything else we should know?",
  order_message_placeholder: "Special circumstances, preferred call times, questions...",
  order_sending: "Sending...",
  order_step_plan: "Plan",
  order_step_parent: "Parent",
  order_step_needs: "Needs",
  order_step_contact: "Contact",
  order_parent_section: "About your parent",
  order_parent_name: "Parent's first name",
  order_parent_name_placeholder: "e.g. Ion",
  order_parent_age: "Parent's age",
  order_parent_age_60_69: "60–69",
  order_parent_age_70_79: "70–79",
  order_parent_age_80_89: "80–89",
  order_parent_age_90_plus: "90+",
  order_parent_country: "Country where they live",
  order_parent_city: "City / town",
  order_parent_city_placeholder: "e.g. Cluj-Napoca",
  order_living_situation: "Living situation",
  order_living_alone: "Lives alone",
  order_living_spouse: "Lives with spouse/partner",
  order_living_family: "Lives with family",
  order_living_care_home: "In a care home",
  order_needs_section: "What kind of help do they need?",
  order_needs_hint: "Select all that apply — this helps us understand demand.",
  order_need_companionship: "Companionship & conversation",
  order_need_meals: "Meal preparation",
  order_need_medication: "Medication reminders",
  order_need_mobility: "Mobility assistance",
  order_need_hygiene: "Personal hygiene help",
  order_need_housekeeping: "Light housekeeping",
  order_need_appointments: "Doctor appointment escort",
  order_need_other: "Other needs",
  order_needs_other_placeholder: "Describe any other care needs...",
  order_timeline: "When would you need care to start?",
  order_timeline_asap: "As soon as possible",
  order_timeline_1_3_months: "Within 1–3 months",
  order_timeline_exploring: "Just exploring options",
  order_preferred_contact: "How should we contact you?",
  order_contact_method_email: "Email",
  order_contact_method_phone: "Phone call",
  order_contact_method_whatsapp: "WhatsApp",
  order_country_serbia: "Serbia",
  order_country_romania: "Romania",
  order_country_north_macedonia: "North Macedonia",
  order_country_bulgaria: "Bulgaria",
  order_country_hungary: "Hungary",
  order_country_other: "Other country",

  dynamic_not_found: "Page Not Found",

  faq_title: "Frequently Asked Questions",
  faq_q1: "What services do you offer?",
  faq_a1: "We offer comprehensive home care services including errands & shopping, cooking & meals, cleaning & tidying, walks & companionship, pharmacy & health support, and social support. All services are provided by vetted, local caregivers.",
  faq_q2: "How does the booking process work?",
  faq_a2: "Simply choose a care plan that fits your family's needs, fill in your details, and either pay the €10 reservation fee or express your interest. A colleague will contact you within 1–2 business days to finalize the details and match you with a caregiver.",
  faq_q3: "What is the €10 reservation fee?",
  faq_a3: "The €10 fee secures your place and shows commitment. It is deducted from your first month's payment. If we cannot provide service in your area, the fee is fully refunded.",
  faq_q4: "Can I cancel my subscription?",
  faq_a4: "Yes, you can cancel at any time with no penalties. We believe in earning your trust every month. Simply contact us and we'll process your cancellation immediately.",
  faq_q5: "What areas do you serve?",
  faq_a5: "We currently operate in five countries: Serbia, Romania, North Macedonia, Bulgaria, and Hungary. We are continuously expanding to new cities and regions within these countries.",
  faq_q6: "How are caregivers selected?",
  faq_a6: "All caregivers go through a thorough vetting process including background checks, reference verification, and in-person interviews. We select people who are not only skilled but genuinely compassionate and trustworthy.",
  faq_q7: "What languages do your caregivers speak?",
  faq_a7: "Our caregivers speak the local language of the country they operate in. Many also speak English or other regional languages. We match caregivers to families based on language preferences whenever possible.",
  faq_q8: "How do I contact you?",
  faq_a8: "You can reach us by email at office@vita-dom.org or by phone. Visit our contact section for full details. We typically respond within one business day.",
};

/** Shared order / market-research form copy — English fallback for sr/mk/bg/hu until localized */
const orderInquiryStrings = Object.fromEntries(
  Object.entries(en_shared).filter(([k]) => k.startsWith("order_")),
) as Pick<TranslationKeys, Extract<keyof TranslationKeys, `order_${string}`>>;

const en_roma: Partial<TranslationKeys> = {
  hero_badge: "Born from the Roma tradition of family devotion",
  hero_subtitle: "Rooted in the Roma spirit of kindness and community — warm, dependable home care for your parents in Serbia, Romania, Macedonia, Bulgaria & Hungary while you're abroad.",
  services_subtitle: "Like a good neighbor from the mahala — our caregivers bring practical help and genuine kindness that keeps your parents happy and independent at home.",
  story_p1: "Vita Dom was born from something personal. Our founding members — Roma professionals living across Europe — faced the same quiet worry every day: who is looking after our parents back home?",
  story_p2: "In Roma culture, abandoning your elders is unthinkable. Family is the foundation of everything. So rather than accept the distance, our founders began organizing care for their own parents — cooking, errands, companionship, pharmacy runs — through trusted local helpers.",
  story_p3: "What started as a family practice quickly became a mission. Through the Roma Foundations for Europe, a respected European foundation, Vita Dom was created to extend this care to every family facing the same struggle — because no parent should feel forgotten.",
  story_card2_title: "Roma Values, European Reach",
  story_card2_desc: "Backed by Roma Foundations for Europe, we bring community-rooted kindness to families across five countries.",
  cta_subtitle: "In Roma tradition, we never abandon our elders. Join hundreds of families keeping that promise across Europe. Your first consultation is free.",
  footer_desc: "Rooted in Roma values of family and kindness — compassionate home care across the Balkans and Central Europe.",
};

// ─── ROMANIAN ───────────────────────────────────────────────────────────────

const ro_shared: TranslationKeys = {
  nav_services: "Servicii",
  nav_howItWorks: "Cum funcționează",
  nav_pricing: "Prețuri",
  nav_testimonials: "Testimoniale",
  nav_getStarted: "Începe acum",

  hero_badge: "Îngrijire de încredere la domiciliu în 5 țări",
  hero_title: "Familia este totul. Noi avem grijă de a ta ca de a noastră.",
  hero_subtitle: "Îngrijire caldă și de încredere la domiciliu pentru părinții tăi din Serbia, România, Macedonia, Bulgaria și Ungaria, în timp ce ești în străinătate.",
  hero_cta: "Începe să ai grijă azi",
  hero_secondary: "Vezi cum funcționează",
  hero_countries: "5 Țări",
  hero_families: "500+ Familii unite",
  hero_caregivers: "Îngrijitori verificați",
  hero_book_service: "Rezervă un serviciu",

  services_label: "Ce facem",
  services_title: "Căldura comunității, chiar la ușa lor",
  services_subtitle: "Îngrijitorii noștri aduc ajutor practic și bunătate autentică care îi ține pe părinții tăi fericiți și independenți acasă.",
  service_errands: "Comisioane și cumpărături",
  service_errands_desc: "Cumpărături, vizite la poștă, plăți facturi — toate comisioanele zilnice gestionate cu grijă.",
  service_cooking: "Gătit și mese",
  service_cooking_desc: "Mese tradiționale gătite în casă, proaspete, respectând nevoile și preferințele alimentare.",
  service_cleaning: "Curățenie",
  service_cleaning_desc: "Menaj regulat pentru a menține casa curată, confortabilă și sigură.",
  service_walks: "Plimbări și companie",
  service_walks_desc: "Plimbări zilnice, vizite sociale și conversații pline de sens pentru a le însenina ziua.",
  service_pharmacy: "Farmacie și sănătate",
  service_pharmacy_desc: "Ridicare rețete, reamintiri medicamente și însoțire la medic.",
  service_social: "Suport social",
  service_social_desc: "Ajutor cu apeluri telefonice, tehnologie și menținerea legăturii cu familia și prietenii.",
  service_book_cta: "Rezervă acest serviciu",

  how_label: "Cum funcționează",
  how_title: "Pași simpli pentru a-ți onora familia",
  how_subtitle: "Distanța nu ar trebui să rupă legătura. În câteva minute, poți aduce mâini grijulii acasă la părinții tăi — totul gestionat de pe telefon, oriunde te-a dus viața.",
  how_step1_title: "Spune-ne despre părinții tăi",
  how_step1_desc: "Împărtășește locația, nevoile și preferințele lor. Îi vom potrivi cu îngrijitorul potrivit din apropiere.",
  how_step2_title: "Alege un plan de îngrijire",
  how_step2_desc: "Alege din planuri flexibile — vizite săptămânale, verificări zilnice sau programe personalizate.",
  how_step3_title: "Îngrijirea începe, tu rămâi informat",
  how_step3_desc: "Părinții tăi primesc ajutor plin de compasiune acasă. Primești actualizări regulate, fotografii și liniște sufletească.",

  pricing_label: "Prețuri",
  pricing_title: "Planuri de îngrijire transparente și accesibile",
  pricing_subtitle: "Fără taxe ascunse. Anulare oricând. Toate planurile includ îngrijitori verificați.",
  pricing_mostPopular: "Cel mai popular",
  pricing_perMonth: "/lună",
  pricing_getStarted: "Începe acum",
  pricing_essential: "Esențial",
  pricing_essential_desc: "Suport ușor pentru părinți independenți",
  pricing_comfort: "Confort",
  pricing_comfort_desc: "Îngrijire zilnică completă și companie",
  pricing_premium: "Premium",
  pricing_premium_desc: "Suport zilnic complet și îngrijire prioritară",
  pricing_feature_2visits: "2 vizite pe săptămână",
  pricing_feature_errands: "Comisioane și cumpărături",
  pricing_feature_housekeeping: "Menaj de bază",
  pricing_feature_weeklyPhotos: "Actualizări foto săptămânale",
  pricing_feature_phoneSupport: "Suport telefonic",
  pricing_feature_5visits: "5 vizite pe săptămână",
  pricing_feature_allEssential: "Toate serviciile Esențial",
  pricing_feature_meals: "Mese gătite în casă",
  pricing_feature_pharmacy: "Suport farmacie și sănătate",
  pricing_feature_dailyPhotos: "Actualizări zilnice cu fotografii",
  pricing_feature_dedicatedCaregiver: "Îngrijitor dedicat",
  pricing_feature_dailyVisits: "Vizite zilnice (7 zile)",
  pricing_feature_allComfort: "Toate serviciile Confort",
  pricing_feature_walks: "Plimbări de companie",
  pricing_feature_doctorVisit: "Însoțire la medic",
  pricing_feature_realtime: "Actualizări în timp real",
  pricing_feature_emergency: "Linie de urgență 24/7",
  pricing_feature_videoReport: "Raport lunar prin video",

  testimonials_label: "Testimoniale",
  testimonials_title: "Familia noastră crește mereu",

  story_label: "Povestea noastră",
  story_title: "Construit de cei care au grijă primii",
  story_p1: "Vita Dom s-a născut din ceva personal. Fondatorii noștri — profesioniști care trăiesc în Europa — se confruntau cu aceeași grijă tăcută în fiecare zi: cine are grijă de părinții noștri acasă?",
  story_p2: "Pentru noi, abandonarea bătrânilor este de neconceput. Familia este fundația a tot. Așa că, în loc să accepte distanța, fondatorii noștri au început să organizeze îngrijire pentru proprii părinți — gătit, comisioane, companie, vizite la farmacie — prin ajutoare locale de încredere.",
  story_p3: "Ceea ce a început ca o practică de familie a devenit rapid o misiune. Vita Dom a fost creat pentru a extinde această grijă la fiecare familie care se confruntă cu aceeași luptă — pentru că niciun părinte nu ar trebui să se simtă uitat.",
  story_card1_title: "Familia mai întâi, mereu",
  story_card1_desc: "Fiecare decizie pe care o luăm începe cu o întrebare: ar fi asta suficient de bun pentru proprii noștri părinți?",
  story_card2_title: "Valori comunitare, acoperire europeană",
  story_card2_desc: "Aducem bunătatea înrădăcinată în comunitate familiilor din cinci țări.",
  story_card3_title: "De la personal la universal",
  story_card3_desc: "Ceea ce a început cu fondatorii îngrijindu-și proprii părinți este acum un serviciu deschis fiecărei familii din diaspora care refuză să lase distanța să câștige.",

  cta_title: "Părinții tăi ți-au dat totul. Acum dă-le înapoi.",
  cta_subtitle: "Nu ne abandonăm niciodată bătrânii. Alătură-te sutelor de familii care păstrează această promisiune în toată Europa. Prima consultație este gratuită.",
  cta_primary: "Consultație gratuită",
  cta_secondary: "Sună-ne",

  footer_desc: "Îngrijire plină de compasiune în Balcani și Europa Centrală — înrădăcinată în valori de familie și bunătate.",
  footer_services: "Servicii",
  footer_countries: "Țări",
  footer_contact: "Contact",
  footer_rights: "Vita Dom. Toate drepturile rezervate.",

  order_title: "Spune-ne despre nevoile de îngrijire ale părinților tăi",
  order_subtitle: "Ajută-ne să înțelegem ce are nevoie familia ta — fără plată, fără angajament. Vom analiza răspunsurile și te vom contacta în 1–2 zile lucrătoare.",
  order_market_badge: "Studiu de piață · Gratuit · Fără plată",
  order_select_plan: "Ce plan de îngrijire te interesează?",
  order_reserve_cta: "Solicită rezervarea",
  order_reserve_note: "Rezervă-ți locul — fără plată acum. Te sunăm în 1–2 zile lucrătoare.",
  order_contact_cta: "Preferi să vorbești direct?",
  order_back: "Înapoi acasă",
  order_success_title: "Mulțumim!",
  order_success_desc: "Am primit cererea ta. Un coleg te va contacta în 1–2 zile lucrătoare.",
  order_processing: "Se procesează...",
  order_your_details: "Datele tale de contact",
  order_name: "Numele tău complet",
  order_name_placeholder: "ex. Maria Popescu",
  order_email: "Emailul tău",
  order_email_placeholder: "adresa@email.com",
  order_phone: "Numărul tău de telefon",
  order_phone_placeholder: "+40 712 345 678",
  order_fill_fields: "Te rugăm completează numele și emailul.",
  order_fill_plan: "Te rugăm selectează un plan de îngrijire.",
  order_fill_needs: "Te rugăm selectează cel puțin un tip de ajutor necesar.",
  order_fill_phone: "Te rugăm adaugă un număr de telefon ca să te putem contacta.",
  order_fill_country: "Te rugăm selectează țara în care locuiește părintele.",
  order_interest_cta: "Trimite cererea mea",
  order_interest_note: "Folosim aceste informații doar pentru a înțelege cererea și a te contacta. Nu este necesară nicio plată.",
  order_interest_success: "Mulțumim — am primit cererea ta!",
  order_interest_success_desc: "Echipa noastră va analiza nevoile de îngrijire și te va contacta în 1–2 zile lucrătoare.",
  order_message: "Altceva ce ar trebui să știm?",
  order_message_placeholder: "Circumstanțe speciale, ore preferate pentru apel, întrebări...",
  order_sending: "Se trimite...",
  order_step_plan: "Plan",
  order_step_parent: "Părinte",
  order_step_needs: "Nevoi",
  order_step_contact: "Contact",
  order_parent_section: "Despre părintele tău",
  order_parent_name: "Prenumele părintelui",
  order_parent_name_placeholder: "ex. Ion",
  order_parent_age: "Vârsta părintelui",
  order_parent_age_60_69: "60–69",
  order_parent_age_70_79: "70–79",
  order_parent_age_80_89: "80–89",
  order_parent_age_90_plus: "90+",
  order_parent_country: "Țara în care locuiește",
  order_parent_city: "Oraș / localitate",
  order_parent_city_placeholder: "ex. Cluj-Napoca",
  order_living_situation: "Situația de locuit",
  order_living_alone: "Locuiește singur/ă",
  order_living_spouse: "Locuiește cu soțul/soția",
  order_living_family: "Locuiește cu familia",
  order_living_care_home: "Într-un centru de îngrijire",
  order_needs_section: "Ce fel de ajutor au nevoie?",
  order_needs_hint: "Selectează tot ce se aplică — ne ajută să înțelegem cererea.",
  order_need_companionship: "Companie și conversație",
  order_need_meals: "Pregătirea meselor",
  order_need_medication: "Reminder medicamente",
  order_need_mobility: "Asistență la deplasare",
  order_need_hygiene: "Ajutor la igiena personală",
  order_need_housekeeping: "Curățenie ușoară",
  order_need_appointments: "Însoțire la doctor",
  order_need_other: "Alte nevoi",
  order_needs_other_placeholder: "Descrie alte nevoi de îngrijire...",
  order_timeline: "Când ar trebui să înceapă îngrijirea?",
  order_timeline_asap: "Cât mai curând posibil",
  order_timeline_1_3_months: "În 1–3 luni",
  order_timeline_exploring: "Doar explorez opțiuni",
  order_preferred_contact: "Cum preferi să te contactăm?",
  order_contact_method_email: "Email",
  order_contact_method_phone: "Apel telefonic",
  order_contact_method_whatsapp: "WhatsApp",
  order_country_serbia: "Serbia",
  order_country_romania: "România",
  order_country_north_macedonia: "Macedonia de Nord",
  order_country_bulgaria: "Bulgaria",
  order_country_hungary: "Ungaria",
  order_country_other: "Altă țară",

  dynamic_not_found: "Pagina nu a fost găsită",

  faq_title: "Întrebări frecvente",
  faq_q1: "Ce servicii oferiți?",
  faq_a1: "Oferim servicii complete de îngrijire la domiciliu, inclusiv comisioane și cumpărături, gătit și mese, curățenie, plimbări și companie, suport farmacie și sănătate, și suport social. Toate serviciile sunt furnizate de îngrijitori locali verificați.",
  faq_q2: "Cum funcționează procesul de rezervare?",
  faq_a2: "Alege un plan de îngrijire potrivit nevoilor familiei tale, completează datele și fie plătește taxa de rezervare de €10, fie exprimă-ți interesul. Un coleg te va contacta în 1–2 zile lucrătoare pentru a finaliza detaliile și a te potrivi cu un îngrijitor.",
  faq_q3: "Ce reprezintă taxa de rezervare de €10?",
  faq_a3: "Taxa de €10 îți asigură locul și demonstrează angajamentul. Este dedusă din plata primei luni. Dacă nu putem oferi servicii în zona ta, taxa este rambursată integral.",
  faq_q4: "Pot anula abonamentul?",
  faq_a4: "Da, poți anula oricând fără penalități. Credem în câștigarea încrederii tale în fiecare lună. Contactează-ne și vom procesa anularea imediat.",
  faq_q5: "Ce zone deserviți?",
  faq_a5: "Operăm în prezent în cinci țări: Serbia, România, Macedonia de Nord, Bulgaria și Ungaria. Ne extindem continuu în noi orașe și regiuni din aceste țări.",
  faq_q6: "Cum sunt selectați îngrijitorii?",
  faq_a6: "Toți îngrijitorii trec printr-un proces riguros de verificare, inclusiv verificări de antecedente, verificarea referințelor și interviuri în persoană. Selectăm persoane care sunt nu doar calificate, ci și cu adevărat compasive și de încredere.",
  faq_q7: "Ce limbi vorbesc îngrijitorii?",
  faq_a7: "Îngrijitorii noștri vorbesc limba locală a țării în care operează. Mulți vorbesc și engleză sau alte limbi regionale. Potrivim îngrijitorii cu familiile pe baza preferințelor lingvistice ori de câte ori este posibil.",
  faq_q8: "Cum vă pot contacta?",
  faq_a8: "Ne poți contacta prin email la office@vita-dom.org sau telefonic. Vizitează secțiunea de contact pentru detalii complete. Răspundem de obicei într-o zi lucrătoare.",
};

const ro_roma: Partial<TranslationKeys> = {
  hero_badge: "Născut din tradiția romă a devotamentului față de familie",
  hero_subtitle: "Înrădăcinați în spiritul rom de bunătate și comunitate — îngrijire caldă și de încredere la domiciliu pentru părinții tăi din Serbia, România, Macedonia, Bulgaria și Ungaria, în timp ce ești în străinătate.",
  services_subtitle: "Ca un vecin bun din mahala — îngrijitorii noștri aduc ajutor practic și bunătate autentică care îi ține pe părinții tăi fericiți și independenți acasă.",
  story_p1: "Vita Dom s-a născut din ceva personal. Membrii noștri fondatori — profesioniști romi care trăiesc în Europa — se confruntau cu aceeași grijă tăcută în fiecare zi: cine are grijă de părinții noștri acasă?",
  story_p2: "În cultura romă, abandonarea bătrânilor este de neconceput. Familia este fundația a tot. Așa că, în loc să accepte distanța, fondatorii noștri au început să organizeze îngrijire pentru proprii părinți — gătit, comisioane, companie, vizite la farmacie — prin ajutoare locale de încredere.",
  story_p3: "Ceea ce a început ca o practică de familie a devenit rapid o misiune. Prin Roma Foundations for Europe, o fundație europeană respectată, Vita Dom a fost creat pentru a extinde această grijă la fiecare familie — pentru că niciun părinte nu ar trebui să se simtă uitat.",
  story_card2_title: "Valori rome, acoperire europeană",
  story_card2_desc: "Susținut de Roma Foundations for Europe, aducem bunătatea înrădăcinată în comunitate familiilor din cinci țări.",
  cta_subtitle: "În tradiția romă, nu ne abandonăm niciodată bătrânii. Alătură-te sutelor de familii care păstrează această promisiune în toată Europa. Prima consultație este gratuită.",
  footer_desc: "Înrădăcinați în valorile rome de familie și bunătate — îngrijire plină de compasiune în Balcani și Europa Centrală.",
};

// ─── SERBIAN ────────────────────────────────────────────────────────────────

const sr_shared: TranslationKeys = {
  nav_services: "Услуге",
  nav_howItWorks: "Како функционише",
  nav_pricing: "Цене",
  nav_testimonials: "Искуства",
  nav_getStarted: "Почни сада",

  hero_badge: "Поуздана кућна нега у 5 земаља",
  hero_title: "Породица је све. Бринемо о вашој као о својој.",
  hero_subtitle: "Топла, поуздана кућна нега за ваше родитеље у Србији, Румунији, Македонији, Бугарској и Мађарској док сте у иностранству.",
  hero_cta: "Почни да бринеш данас",
  hero_secondary: "Погледај како функционише",
  hero_countries: "5 земаља",
  hero_families: "500+ уједињених породица",
  hero_caregivers: "Проверени неговатељи",
  hero_book_service: "Резервиши услугу",

  services_label: "Шта радимо",
  services_title: "Топлина заједнице, право на њиховим вратима",
  services_subtitle: "Наши неговатељи доносе практичну помоћ и искрену доброту која ваше родитеље чува срећним и самосталним код куће.",
  service_errands: "Поруџбине и куповина",
  service_errands_desc: "Куповина намирница, одлазак на пошту, плаћање рачуна — сви дневни послови обављени с пажњом.",
  service_cooking: "Кување и оброци",
  service_cooking_desc: "Традиционални домаћи оброци припремљени свеже, уз поштовање дијететских потреба.",
  service_cleaning: "Чишћење",
  service_cleaning_desc: "Редовно одржавање домаћинства за чист, удобан и безбедан дом.",
  service_walks: "Шетње и дружење",
  service_walks_desc: "Свакодневне шетње, друштвене посете и смислени разговори да им улепшају дан.",
  service_pharmacy: "Апотека и здравље",
  service_pharmacy_desc: "Подизање рецепата, подсетници за лекове и пратња до лекара.",
  service_social: "Социјална подршка",
  service_social_desc: "Помоћ са телефонским позивима, технологијом и одржавањем везе са породицом и пријатељима.",
  service_book_cta: "Резервиши ову услугу",

  how_label: "Како функционише",
  how_title: "Једноставни кораци да поштујете своју породицу",
  how_subtitle: "Раздаљина не би требало да прекине везу. За неколико минута можете довести бринне руке у дом ваших родитеља — управљано са вашег телефона, где год вас живот одвео.",
  how_step1_title: "Реците нам о вашим родитељима",
  how_step1_desc: "Поделите њихову локацију, потребе и преференције. Упарићемо их са правим неговатељем у близини.",
  how_step2_title: "Изаберите план неге",
  how_step2_desc: "Изаберите из флексибилних планова — недељне посете, дневне провере или прилагођени распоред.",
  how_step3_title: "Нега почиње, ви остајете информисани",
  how_step3_desc: "Ваши родитељи добијају саосећајну помоћ код куће. Добијате редовне извештаје, фотографије и мир.",

  pricing_label: "Цене",
  pricing_title: "Транспарентни, приступачни планови неге",
  pricing_subtitle: "Без скривених трошкова. Откажите кад желите. Сви планови укључују проверене неговатеље.",
  pricing_mostPopular: "Најпопуларнији",
  pricing_perMonth: "/месечно",
  pricing_getStarted: "Почни сада",
  pricing_essential: "Основни",
  pricing_essential_desc: "Лака подршка за самосталне родитеље",
  pricing_comfort: "Комфор",
  pricing_comfort_desc: "Свеобухватна дневна нега и дружење",
  pricing_premium: "Премиум",
  pricing_premium_desc: "Потпуна дневна подршка и приоритетна нега",
  pricing_feature_2visits: "2 посете недељно",
  pricing_feature_errands: "Поруџбине и куповина",
  pricing_feature_housekeeping: "Основно одржавање",
  pricing_feature_weeklyPhotos: "Недељни фото извештаји",
  pricing_feature_phoneSupport: "Телефонска подршка",
  pricing_feature_5visits: "5 посета недељно",
  pricing_feature_allEssential: "Све услуге Основног плана",
  pricing_feature_meals: "Домаћи оброци",
  pricing_feature_pharmacy: "Апотека и здравствена подршка",
  pricing_feature_dailyPhotos: "Дневни извештаји са фотографијама",
  pricing_feature_dedicatedCaregiver: "Посвећен неговатељ",
  pricing_feature_dailyVisits: "Дневне посете (7 дана)",
  pricing_feature_allComfort: "Све услуге Комфор плана",
  pricing_feature_walks: "Шетње уз дружење",
  pricing_feature_doctorVisit: "Пратња до лекара",
  pricing_feature_realtime: "Извештаји у реалном времену",
  pricing_feature_emergency: "24/7 хитна линија",
  pricing_feature_videoReport: "Месечни видео извештај",

  testimonials_label: "Искуства",
  testimonials_title: "Наша породица расте",

  story_label: "Наша прича",
  story_title: "Изградили они који прво брину",
  story_p1: "Vita Dom је рођен из нечег личног. Наши оснивачи — професионалци који живе широм Европе — суочавали су се са истом тихом бригом сваки дан: ко води рачуна о нашим родитељима код куће?",
  story_p2: "За нас, напуштање старијих је незамисливо. Породица је темељ свега. Уместо да прихвате удаљеност, наши оснивачи су почели да организују негу за своје родитеље — кување, поруџбине, дружење, одласке у апотеку — преко поузданих локалних помоћника.",
  story_p3: "Оно што је почело као породична пракса брзо је постало мисија. Vita Dom је створен да прошири ову бригу на сваку породицу — јер ниједан родитељ не треба да се осећа заборављеним.",
  story_card1_title: "Породица прво, увек",
  story_card1_desc: "Свака наша одлука почиње једним питањем: да ли би ово било довољно добро за наше сопствене родитеље?",
  story_card2_title: "Вредности заједнице, европски домет",
  story_card2_desc: "Доносимо доброту укорењену у заједници породицама у пет земаља.",
  story_card3_title: "Од личног до универзалног",
  story_card3_desc: "Оно што је почело као брига оснивача о сопственим родитељима сада је услуга отворена за сваку породицу из дијаспоре.",

  cta_title: "Ваши родитељи су вам дали све. Сада узвратите.",
  cta_subtitle: "Никада не напуштамо наше старије. Придружите се стотинама породица које чувају то обећање широм Европе. Прва консултација је бесплатна.",
  cta_primary: "Бесплатна консултација",
  cta_secondary: "Позовите нас",

  footer_desc: "Саосећајна кућна нега широм Балкана и Централне Европе — укорењена у породичним вредностима и доброти.",
  footer_services: "Услуге",
  footer_countries: "Земље",
  footer_contact: "Контакт",
  footer_rights: "Vita Dom. Сва права задржана.",

  order_title: "Поруџбина плана неге",
  order_subtitle: "Изаберите план, попуните своје податке и пошаљите захтев. Колега ће вас позвати у року од 1–2 радна дана.",
  order_select_plan: "Изаберите план",
  order_reserve_cta: "Затражите резервацију",
  order_reserve_note: "Резервишите место — без плаћања сада. Позваћемо вас за 1–2 радна дана да завршимо регистрацију.",
  order_contact_cta: "Контактирајте нас",
  order_back: "Назад на почетну",
  order_success_title: "Резервација потврђена!",
  order_success_desc: "Хвала! Ваш захтев за резервацију је примљен. Позваћемо вас у року од 1–2 радна дана.",
  order_processing: "Обрада...",
  order_your_details: "Ваши подаци",
  order_name: "Пуно име",
  order_name_placeholder: "нпр. Марија Поповић",
  order_email: "Имејл",
  order_email_placeholder: "ваш@имејл.com",
  order_phone: "Телефон (опционално)",
  order_phone_placeholder: "+381 61 123 4567",
  order_fill_fields: "Молимо попуните име и имејл.",
  order_interest_cta: "Пошаљите захтев за резервацију",
  order_interest_note: "Плаћање није потребно сada. Контактираћемо вас у року од 1–2 радна дана да разговарамо о плану неге.",
  order_interest_success: "Хвала на интересовању!",
  order_interest_success_desc: "Колега ће вас контактирати у року од 1–2 радна дана.",
  order_message: "Порука (опционо)",
  order_message_placeholder: "Питања или детаљи које желите да поделите...",
  order_sending: "Слање...",

  dynamic_not_found: "Страница није пронађена",

  faq_title: "Често постављана питања",
  faq_q1: "Које услуге нудите?",
  faq_a1: "Нудимо свеобухватне услуге кућне неге укључујући поруџбине и куповину, кување и оброке, чишћење, шетње и дружење, подршку за апотеку и здравље, и социјалну подршку. Све услуге пружају проверени, локални неговатељи.",
  faq_q2: "Како функционише процес резервације?",
  faq_a2: "Једноставно изаберите план неге који одговара потребама ваше породице, попуните своје податке и или платите резервацију од €10 или изразите своје интересовање. Колега ће вас контактирати у року од 1–2 радна дана да финализује детаље и упари вас са неговатељем.",
  faq_q3: "Шта представља резервација од €10?",
  faq_a3: "Накнада од €10 обезбеђује ваше место и показује посвећеност. Одузима се од плаћања за први месец. Ако не можемо да пружимо услугу у вашој области, накнада се у потпуности враћа.",
  faq_q4: "Могу ли да откажем претплату?",
  faq_a4: "Да, можете отказати у било ком тренутку без казни. Верујемо у заслуживање вашег поверења сваког месеца. Једноставно нас контактирајте и одмах ћемо обрадити ваш отказ.",
  faq_q5: "Које области покривате?",
  faq_a5: "Тренутно радимо у пет земаља: Србија, Румунија, Северна Македонија, Бугарска и Мађарска. Непрестано се ширимо на нове градове и регионе у овим земљама.",
  faq_q6: "Како се бирају неговатељи?",
  faq_a6: "Сви неговатељи пролазе кроз темељан процес провере укључујући проверу прошлости, верификацију референци и интервјуе уживо. Бирамо људе који су не само вешти већ и искрено саосећајни и поуздани.",
  faq_q7: "Које језике говоре ваши неговатељи?",
  faq_a7: "Наши неговатељи говоре локални језик земље у којој раде. Многи такође говоре енглески или друге регионалне језике. Упаримо неговатеље са породицама на основу језичких преференција кад год је могуће.",
  faq_q8: "Како да вас контактирам?",
  faq_a8: "Можете нас контактирати имејлом на office@vita-dom.org или телефоном. Посетите нашу секцију за контакт за све детаље. Обично одговарамо у року од једног радног дана.",
};

const sr_roma: Partial<TranslationKeys> = {
  hero_badge: "Рођено из ромске традиције посвећености породици",
  hero_subtitle: "Укорењени у ромском духу доброте и заједнице — топла, поуздана кућна нега за ваше родитеље у Србији, Румунији, Македонији, Бугарској и Мађарској док сте у иностранству.",
  services_subtitle: "Као добар комшија из махале — наши неговатељи доносе практичну помоћ и искрену доброту која ваше родитеље чува срећним и самосталним код куће.",
  story_p1: "Vita Dom је рођен из нечег личног. Наши чланови оснивачи — ромски професионалци који живе широм Европе — суочавали су се са истом тихом бригом сваки дан: ко води рачуна о нашим родитељима код куће?",
  story_p2: "У ромској култури, напуштање старијих је незамисливо. Породица је темељ свега. Уместо да прихвате удаљеност, наши оснивачи су почели да организују негу за своје родитеље — кување, поруџбине, дружење, одласке у апотеку — преко поузданих локалних помоћника.",
  story_p3: "Оно што је почело као породична пракса брзо је постало мисија. Преко Roma Foundations for Europe, угледне европске фондације, Vita Dom је створен да прошири ову бригу на сваку породицу — јер ниједан родитељ не треба да се осећа заборављеним.",
  story_card2_title: "Ромске вредности, европски домет",
  story_card2_desc: "Подржан од Roma Foundations for Europe, доносимо доброту укорењену у заједници породицама у пет земаља.",
  cta_subtitle: "У ромској традицији, никада не напуштамо наше старије. Придружите се стотинама породица које чувају то обећање широм Европе. Прва консултација је бесплатна.",
  footer_desc: "Укорењени у ромским вредностима породице и доброте — саосећајна кућна нега широм Балкана и Централне Европе.",
};

// ─── MACEDONIAN ─────────────────────────────────────────────────────────────

const mk_shared: TranslationKeys = {
  nav_services: "Услуги",
  nav_howItWorks: "Како функционира",
  nav_pricing: "Цени",
  nav_testimonials: "Искуства",
  nav_getStarted: "Започни сега",

  hero_badge: "Доверлива домашна нега во 5 земји",
  hero_title: "Семејството е сè. Ние се грижиме за вашето како за наше.",
  hero_subtitle: "Топла, сигурна домашна нега за вашите родители во Србија, Романија, Македонија, Бугарија и Унгарија додека сте во странство.",
  hero_cta: "Започни да се грижиш денес",
  hero_secondary: "Погледни како функционира",
  hero_countries: "5 земји",
  hero_families: "500+ обединети семејства",
  hero_caregivers: "Проверени негуватели",
  hero_book_service: "Резервирај услуга",

  services_label: "Што правиме",
  services_title: "Топлината на заедницата, точно на нивната врата",
  services_subtitle: "Нашите негуватели носат практична помош и искрена добрина што ги чува вашите родители среќни и самостојни дома.",
  service_errands: "Обврски и купување",
  service_errands_desc: "Купување намирници, посета на пошта, плаќање сметки — сите дневни обврски со грижа.",
  service_cooking: "Готвење и оброци",
  service_cooking_desc: "Традиционални домашни оброци подготвени свежи, со почитување на диететските потреби.",
  service_cleaning: "Чистење",
  service_cleaning_desc: "Редовно одржување на домаќинството за чист, удобен и безбеден дом.",
  service_walks: "Прошетки и дружење",
  service_walks_desc: "Дневни прошетки, социјални посети и смислени разговори за да им го разубават денот.",
  service_pharmacy: "Аптека и здравје",
  service_pharmacy_desc: "Подигнување рецепти, потсетници за лекови и придружување до доктор.",
  service_social: "Социјална поддршка",
  service_social_desc: "Помош со телефонски повици, технологија и одржување врска со семејството и пријателите.",
  service_book_cta: "Резервирај ја оваа услуга",

  how_label: "Како функционира",
  how_title: "Едноставни чекори за да го почитувате вашето семејство",
  how_subtitle: "Растојанието не треба да ја прекине врската. За неколку минути можете да донесете грижливи раце во домот на вашите родители.",
  how_step1_title: "Кажете ни за вашите родители",
  how_step1_desc: "Споделете ја нивната локација, потреби и преференции. Ќе ги поврземе со вистинскиот негувател во близина.",
  how_step2_title: "Изберете план за нега",
  how_step2_desc: "Изберете од флексибилни планови — неделни посети, дневни проверки или прилагоден распоред.",
  how_step3_title: "Негата започнува, вие останувате информирани",
  how_step3_desc: "Вашите родители добиваат сочувствителна помош дома. Добивате редовни извештаи, фотографии и мир.",

  pricing_label: "Цени",
  pricing_title: "Транспарентни, достапни планови за нега",
  pricing_subtitle: "Без скриени трошоци. Откажете кога сакате. Сите планови вклучуваат проверени негуватели.",
  pricing_mostPopular: "Најпопуларен",
  pricing_perMonth: "/месечно",
  pricing_getStarted: "Започни сега",
  pricing_essential: "Основен",
  pricing_essential_desc: "Лесна поддршка за самостојни родители",
  pricing_comfort: "Комфор",
  pricing_comfort_desc: "Сеопфатна дневна нега и дружење",
  pricing_premium: "Премиум",
  pricing_premium_desc: "Целосна дневна поддршка и приоритетна нега",
  pricing_feature_2visits: "2 посети неделно",
  pricing_feature_errands: "Обврски и купување",
  pricing_feature_housekeeping: "Основно одржување",
  pricing_feature_weeklyPhotos: "Неделни фото извештаи",
  pricing_feature_phoneSupport: "Телефонска поддршка",
  pricing_feature_5visits: "5 посети неделно",
  pricing_feature_allEssential: "Сите услуги од Основен план",
  pricing_feature_meals: "Домашни оброци",
  pricing_feature_pharmacy: "Аптека и здравствена поддршка",
  pricing_feature_dailyPhotos: "Дневни извештаи со фотографии",
  pricing_feature_dedicatedCaregiver: "Посветен негувател",
  pricing_feature_dailyVisits: "Дневни посети (7 дена)",
  pricing_feature_allComfort: "Сите услуги од Комфор план",
  pricing_feature_walks: "Прошетки со дружење",
  pricing_feature_doctorVisit: "Придружување до доктор",
  pricing_feature_realtime: "Извештаи во реално време",
  pricing_feature_emergency: "24/7 итна линија",
  pricing_feature_videoReport: "Месечен видео извештај",

  testimonials_label: "Искуства",
  testimonials_title: "Нашето семејство расте",

  story_label: "Нашата приказна",
  story_title: "Изградено од оние кои прво се грижат",
  story_p1: "Vita Dom се роди од нешто лично. Нашите основачи — професионалци кои живеат низ Европа — се соочуваа со истата тивка грижа секој ден: кој се грижи за нашите родители дома?",
  story_p2: "За нас, напуштањето на постарите е незамисливо. Семејството е темел на сè. Наместо да ја прифатат далечината, нашите основачи почнаа да организираат нега за своите родители — готвење, обврски, дружење, посети на аптека — преку доверливи локални помошници.",
  story_p3: "Тоа што започна како семејна практика брзо стана мисија. Vita Dom беше создаден за да ја прошири оваа грижа на секое семејство — затоа што ниеден родител не треба да се чувствува заборавен.",
  story_card1_title: "Семејството прво, секогаш",
  story_card1_desc: "Секоја наша одлука започнува со едно прашање: дали ова би било доволно добро за нашите сопствени родители?",
  story_card2_title: "Вредности на заедницата, европски дофат",
  story_card2_desc: "Носиме добрина вкоренета во заедницата на семејства во пет земји.",
  story_card3_title: "Од лично до универзално",
  story_card3_desc: "Тоа што започна со основачите грижејќи се за своите родители сега е услуга отворена за секое семејство од дијаспората.",

  cta_title: "Вашите родители ви дадоа сè. Сега возвратете.",
  cta_subtitle: "Никогаш не ги напуштаме нашите постари. Придружете се на стотици семејства кои го чуваат тоа ветување низ Европа. Првата консултација е бесплатна.",
  cta_primary: "Бесплатна консултација",
  cta_secondary: "Повикајте нè",

  footer_desc: "Сочувствителна домашна нега низ Балканот и Централна Европа — вкоренета во семејни вредности и добрина.",
  footer_services: "Услуги",
  footer_countries: "Земји",
  footer_contact: "Контакт",
  footer_rights: "Vita Dom. Сите права задржани.",

  order_title: "Нарачајте план за нега",
  order_subtitle: "Изберете план, пополнете ги вашите податоци и испратете барање. Колега ќе ве контактира во рок од 1–2 работни дена.",
  order_select_plan: "Изберете план",
  order_reserve_cta: "Побарајте резервација",
  order_reserve_note: "Резервирајте место — без плаќање сега. Ќе ве повикаме за 1–2 работни дена за да ја завршиме регистрацијата.",
  order_contact_cta: "Контактирајте нè",
  order_back: "Назад на почетна",
  order_success_title: "Резервацијата е потврдена!",
  order_success_desc: "Ви благодариме! Вашето барање за резервација е примено. Ќе ве повикаме во рок од 1–2 работни дена.",
  order_processing: "Се обработува...",
  order_your_details: "Вашите податоци",
  order_name: "Целосно име",
  order_name_placeholder: "пр. Марија Петровска",
  order_email: "Е-пошта",
  order_email_placeholder: "вашата@е-пошта.com",
  order_phone: "Телефон (опционално)",
  order_phone_placeholder: "+389 70 123 456",
  order_fill_fields: "Ве молиме пополнете го името и е-поштата.",
  order_interest_cta: "Испратете барање за резервација",
  order_interest_note: "Плаќање не е потребно сега. Ќе ве контактираме во рок од 1–2 работни дена за да разговараме за планот за нега.",
  order_interest_success: "Ви благодариме за интересот!",
  order_interest_success_desc: "Колега ќе ве контактира во рок од 1–2 работни дена.",
  order_message: "Порака (опционо)",
  order_message_placeholder: "Прашања или детали што сакате да ги споделите...",
  order_sending: "Се испраќа...",

  dynamic_not_found: "Страницата не е пронајдена",

  faq_title: "Често поставувани прашања",
  faq_q1: "Кои услуги ги нудите?",
  faq_a1: "Нудиме сеопфатни услуги за домашна нега вклучувајќи обврски и купување, готвење и оброци, чистење, прошетки и дружење, поддршка за аптека и здравје, и социјална поддршка. Сите услуги се обезбедени од проверени, локални негуватели.",
  faq_q2: "Како функционира процесот на резервација?",
  faq_a2: "Едноставно изберете план за нега што одговара на потребите на вашето семејство, пополнете ги вашите податоци и или платете ја резервацијата од €10 или изразете го вашиот интерес. Колега ќе ве контактира во рок од 1–2 работни дена за да ги финализира деталите и да ве поврзе со негувател.",
  faq_q3: "Што претставува резервацијата од €10?",
  faq_a3: "Надоместокот од €10 го обезбедува вашето место и покажува посветеност. Се одзема од плаќањето за првиот месец. Ако не можеме да обезбедиме услуга во вашата област, надоместокот целосно се враќа.",
  faq_q4: "Можам ли да ја откажам претплатата?",
  faq_a4: "Да, можете да откажете во секое време без казни. Веруваме во заслужување на вашата доверба секој месец. Едноставно контактирајте нè и веднаш ќе го обработиме вашиот отказ.",
  faq_q5: "Кои области ги покривате?",
  faq_a5: "Моментално работиме во пет земји: Србија, Романија, Северна Македонија, Бугарија и Унгарија. Постојано се шириме во нови градови и региони во овие земји.",
  faq_q6: "Како се избираат негувателите?",
  faq_a6: "Сите негуватели поминуваат низ темелен процес на проверка вклучувајќи проверка на минатото, верификација на референци и интервјуа во живо. Избираме луѓе кои се не само вешти туку и искрено сочувствителни и доверливи.",
  faq_q7: "Кои јазици ги зборуваат вашите негуватели?",
  faq_a7: "Нашите негуватели го зборуваат локалниот јазик на земјата во која работат. Многу од нив зборуваат и англиски или други регионални јазици. Ги поврзуваме негувателите со семејствата врз основа на јазичните преференции секогаш кога е можно.",
  faq_q8: "Како да ве контактирам?",
  faq_a8: "Можете да нè контактирате по е-пошта на office@vita-dom.org или телефонски. Посетете ја нашата секција за контакт за сите детали. Обично одговараме во рок од еден работен ден.",
};

const mk_roma: Partial<TranslationKeys> = {
  hero_badge: "Родено од ромската традиција на семејна посветеност",
  hero_subtitle: "Вкоренети во ромскиот дух на добрина и заедница — топла, сигурна домашна нега за вашите родители во Србија, Романија, Македонија, Бугарија и Унгарија додека сте во странство.",
  services_subtitle: "Како добар сосед од махалата — нашите негуватели носат практична помош и искрена добрина што ги чува вашите родители среќни и самостојни дома.",
  story_p1: "Vita Dom се роди од нешто лично. Нашите основачи — ромски професионалци кои живеат низ Европа — се соочуваа со истата тивка грижа секој ден: кој се грижи за нашите родители дома?",
  story_p2: "Во ромската култура, напуштањето на постарите е незамисливо. Семејството е темел на сè. Наместо да ја прифатат далечината, нашите основачи почнаа да организираат нега за своите родители — готвење, обврски, дружење, посети на аптека — преку доверливи локални помошници.",
  story_p3: "Тоа што започна како семејна практика брзо стана мисија. Преку Roma Foundations for Europe, почитувана европска фондација, Vita Dom беше создаден за да ја прошири оваа грижа на секое семејство — затоа што ниеден родител не треба да се чувствува заборавен.",
  story_card2_title: "Ромски вредности, европски дофат",
  story_card2_desc: "Поддржан од Roma Foundations for Europe, носиме добрина вкоренета во заедницата на семејства во пет земји.",
  cta_subtitle: "Во ромската традиција, никогаш не ги напуштаме нашите постари. Придружете се на стотици семејства кои го чуваат тоа ветување низ Европа. Првата консултација е бесплатна.",
  footer_desc: "Вкоренети во ромските вредности на семејство и добрина — сочувствителна домашна нега низ Балканот и Централна Европа.",
};

// ─── BULGARIAN ──────────────────────────────────────────────────────────────

const bg_shared: TranslationKeys = {
  nav_services: "Услуги",
  nav_howItWorks: "Как работи",
  nav_pricing: "Цени",
  nav_testimonials: "Отзиви",
  nav_getStarted: "Започни сега",

  hero_badge: "Надеждна домашна грижа в 5 страни",
  hero_title: "Семейството е всичко. Ние се грижим за вашето като за наше.",
  hero_subtitle: "Топла, надеждна домашна грижа за вашите родители в Сърбия, Румъния, Македония, България и Унгария, докато сте в чужбина.",
  hero_cta: "Започни да се грижиш днес",
  hero_secondary: "Виж как работи",
  hero_countries: "5 страни",
  hero_families: "500+ обединени семейства",
  hero_caregivers: "Проверени гледачи",
  hero_book_service: "Резервирай услуга",

  services_label: "Какво правим",
  services_title: "Топлината на общността, точно на вратата им",
  services_subtitle: "Нашите гледачи носят практична помощ и искрена доброта, която държи родителите ви щастливи и независими у дома.",
  service_errands: "Поръчки и пазаруване",
  service_errands_desc: "Пазаруване, посещения на пощата, плащане на сметки — всички ежедневни поръчки с грижа.",
  service_cooking: "Готвене и хранене",
  service_cooking_desc: "Традиционни домашни ястия, приготвени прясно, с уважение към хранителните нужди.",
  service_cleaning: "Почистване",
  service_cleaning_desc: "Редовно поддържане на домакинството за чист, удобен и безопасен дом.",
  service_walks: "Разходки и компания",
  service_walks_desc: "Ежедневни разходки, социални посещения и смислени разговори за по-ведър ден.",
  service_pharmacy: "Аптека и здраве",
  service_pharmacy_desc: "Взимане на рецепти, напомняне за лекарства и придружаване до лекар.",
  service_social: "Социална подкрепа",
  service_social_desc: "Помощ с телефонни обаждания, технологии и поддържане на връзка със семейството.",
  service_book_cta: "Резервирай тази услуга",

  how_label: "Как работи",
  how_title: "Прости стъпки за да почетете семейството си",
  how_subtitle: "Разстоянието не трябва да прекъсва връзката. За минути можете да доведете грижовни ръце в дома на родителите си.",
  how_step1_title: "Разкажете ни за родителите си",
  how_step1_desc: "Споделете тяхното местоположение, нужди и предпочитания. Ще ги свържем с подходящия гледач наблизо.",
  how_step2_title: "Изберете план за грижа",
  how_step2_desc: "Изберете от гъвкави планове — седмични посещения, ежедневни проверки или персонализиран график.",
  how_step3_title: "Грижата започва, вие оставате информирани",
  how_step3_desc: "Родителите ви получават състрадателна помощ у дома. Получавате редовни актуализации, снимки и спокойствие.",

  pricing_label: "Цени",
  pricing_title: "Прозрачни, достъпни планове за грижа",
  pricing_subtitle: "Без скрити такси. Откажете по всяко време. Всички планове включват проверени гледачи.",
  pricing_mostPopular: "Най-популярен",
  pricing_perMonth: "/месечно",
  pricing_getStarted: "Започни сега",
  pricing_essential: "Основен",
  pricing_essential_desc: "Лека подкрепа за независими родители",
  pricing_comfort: "Комфорт",
  pricing_comfort_desc: "Цялостна ежедневна грижа и компания",
  pricing_premium: "Премиум",
  pricing_premium_desc: "Пълна ежедневна подкрепа и приоритетна грижа",
  pricing_feature_2visits: "2 посещения седмично",
  pricing_feature_errands: "Поръчки и пазаруване",
  pricing_feature_housekeeping: "Основно поддържане",
  pricing_feature_weeklyPhotos: "Седмични фото актуализации",
  pricing_feature_phoneSupport: "Телефонна подкрепа",
  pricing_feature_5visits: "5 посещения седмично",
  pricing_feature_allEssential: "Всички услуги от Основен план",
  pricing_feature_meals: "Домашни ястия",
  pricing_feature_pharmacy: "Аптека и здравна подкрепа",
  pricing_feature_dailyPhotos: "Ежедневни актуализации със снимки",
  pricing_feature_dedicatedCaregiver: "Посветен гледач",
  pricing_feature_dailyVisits: "Ежедневни посещения (7 дни)",
  pricing_feature_allComfort: "Всички услуги от Комфорт план",
  pricing_feature_walks: "Разходки с компания",
  pricing_feature_doctorVisit: "Придружаване до лекар",
  pricing_feature_realtime: "Актуализации в реално време",
  pricing_feature_emergency: "24/7 спешна линия",
  pricing_feature_videoReport: "Месечен видео отчет",

  testimonials_label: "Отзиви",
  testimonials_title: "Нашето семейство расте",

  story_label: "Нашата история",
  story_title: "Изградено от тези, които първо се грижат",
  story_p1: "Vita Dom се роди от нещо лично. Нашите основатели — професионалисти, живеещи из Европа — се сблъскваха с една и съща тиха тревога всеки ден: кой се грижи за родителите ни у дома?",
  story_p2: "За нас изоставянето на възрастните е немислимо. Семейството е основата на всичко. Вместо да приемат разстоянието, нашите основатели започнаха да организират грижа за собствените си родители — готвене, поръчки, компания, посещения на аптеката — чрез доверени местни помощници.",
  story_p3: "Това, което започна като семейна практика, бързо стана мисия. Vita Dom беше създаден за да разшири тази грижа до всяко семейство — защото нито един родител не трябва да се чувства забравен.",
  story_card1_title: "Семейството първо, винаги",
  story_card1_desc: "Всяко наше решение започва с един въпрос: достатъчно добро ли е това за нашите собствени родители?",
  story_card2_title: "Ценности на общността, европейски обхват",
  story_card2_desc: "Носим доброта, вкоренена в общността, на семейства в пет страни.",
  story_card3_title: "От лично до универсално",
  story_card3_desc: "Това, което започна с основателите, грижещи се за собствените си родители, сега е услуга за всяко семейство от диаспората.",

  cta_title: "Родителите ви са ви дали всичко. Сега им върнете.",
  cta_subtitle: "Никога не изоставяме възрастните си. Присъединете се към стотици семейства, пазещи това обещание из Европа. Първата консултация е безплатна.",
  cta_primary: "Безплатна консултация",
  cta_secondary: "Обадете ни се",

  footer_desc: "Състрадателна домашна грижа из Балканите и Централна Европа — вкоренена в семейни ценности и доброта.",
  footer_services: "Услуги",
  footer_countries: "Страни",
  footer_contact: "Контакт",
  footer_rights: "Vita Dom. Всички права запазени.",

  order_title: "Поръчайте план за грижа",
  order_subtitle: "Изберете план, попълнете данните си и изпратете заявката. Колега ще се свърже с вас в рамките на 1–2 работни дни.",
  order_select_plan: "Изберете план",
  order_reserve_cta: "Заявете резервация",
  order_reserve_note: "Резервирайте мястото си — без плащане сега. Ще ви се обадим в рамките на 1–2 работни дни, за да завършим регистрацията.",
  order_contact_cta: "Свържете се с нас",
  order_back: "Обратно към началото",
  order_success_title: "Резервацията е потвърдена!",
  order_success_desc: "Благодарим! Вашата заявка за резервация е получена. Ще ви се обадим в рамките на 1–2 работни дни.",
  order_processing: "Обработва се...",
  order_your_details: "Вашите данни",
  order_name: "Пълно име",
  order_name_placeholder: "напр. Мария Петрова",
  order_email: "Имейл",
  order_email_placeholder: "вашият@имейл.com",
  order_phone: "Телефон (по избор)",
  order_phone_placeholder: "+359 88 123 4567",
  order_fill_fields: "Моля, попълнете името и имейла си.",
  order_interest_cta: "Изпратете заявка за резервация",
  order_interest_note: "Не се изисква плащане сега. Ще се свържем с вас в рамките на 1–2 работни дни, за да обсъдим плана за грижа.",
  order_interest_success: "Благодарим за интереса!",
  order_interest_success_desc: "Колега ще се свърже с вас в рамките на 1–2 работни дни.",
  order_message: "Съобщение (по избор)",
  order_message_placeholder: "Въпроси или подробности, които искате да споделите...",
  order_sending: "Изпращане...",

  dynamic_not_found: "Страницата не е намерена",

  faq_title: "Често задавани въпроси",
  faq_q1: "Какви услуги предлагате?",
  faq_a1: "Предлагаме цялостни услуги за домашна грижа, включително поръчки и пазаруване, готвене и хранене, почистване, разходки и компания, подкрепа за аптека и здраве, и социална подкрепа. Всички услуги се предоставят от проверени, местни гледачи.",
  faq_q2: "Как работи процесът на резервация?",
  faq_a2: "Просто изберете план за грижа, който отговаря на нуждите на семейството ви, попълнете данните си и или платете таксата за резервация от €10, или изразете интереса си. Колега ще се свърже с вас в рамките на 1–2 работни дни, за да финализира подробностите и да ви свърже с гледач.",
  faq_q3: "Какво представлява таксата за резервация от €10?",
  faq_a3: "Таксата от €10 осигурява вашето място и показва ангажираност. Тя се приспада от плащането за първия месец. Ако не можем да предоставим услуга във вашия район, таксата се възстановява изцяло.",
  faq_q4: "Мога ли да отменя абонамента си?",
  faq_a4: "Да, можете да отмените по всяко време без неустойки. Вярваме в спечелването на вашето доверие всеки месец. Просто се свържете с нас и ще обработим отмяната ви незабавно.",
  faq_q5: "Какви области обслужвате?",
  faq_a5: "В момента работим в пет страни: Сърбия, Румъния, Северна Македония, България и Унгария. Непрекъснато се разширяваме в нови градове и региони в тези страни.",
  faq_q6: "Как се подбират гледачите?",
  faq_a6: "Всички гледачи преминават през задълбочен процес на проверка, включително проверка на миналото, верификация на препоръки и лични интервюта. Избираме хора, които са не само умели, но и истински състрадателни и надеждни.",
  faq_q7: "Какви езици говорят вашите гледачи?",
  faq_a7: "Нашите гледачи говорят местния език на страната, в която работят. Много от тях говорят и английски или други регионални езици. Свързваме гледачите със семействата въз основа на езиковите предпочитания, когато е възможно.",
  faq_q8: "Как да се свържа с вас?",
  faq_a8: "Можете да се свържете с нас по имейл на office@vita-dom.org или по телефона. Посетете нашата секция за контакт за пълни подробности. Обикновено отговаряме в рамките на един работен ден.",
};

const bg_roma: Partial<TranslationKeys> = {
  hero_badge: "Родено от ромската традиция на семейна преданост",
  hero_subtitle: "Вкоренени в ромския дух на доброта и общност — топла, надеждна домашна грижа за вашите родители в Сърбия, Румъния, Македония, България и Унгария, докато сте в чужбина.",
  services_subtitle: "Като добър съсед от махалата — нашите гледачи носят практична помощ и искрена доброта, която държи родителите ви щастливи и независими у дома.",
  story_p1: "Vita Dom се роди от нещо лично. Нашите основатели — ромски професионалисти, живеещи из Европа — се сблъскваха с една и съща тиха тревога всеки ден: кой се грижи за родителите ни у дома?",
  story_p2: "В ромската култура изоставянето на възрастните е немислимо. Семейството е основата на всичко. Вместо да приемат разстоянието, нашите основатели започнаха да организират грижа за собствените си родители — готвене, поръчки, компания, посещения на аптеката — чрез доверени местни помощници.",
  story_p3: "Това, което започна като семейна практика, бързо стана мисия. Чрез Roma Foundations for Europe, уважавана европейска фондация, Vita Dom беше създаден за да разшири тази грижа до всяко семейство — защото нито един родител не трябва да се чувства забравен.",
  story_card2_title: "Ромски ценности, европейски обхват",
  story_card2_desc: "Подкрепен от Roma Foundations for Europe, носим доброта, вкоренена в общността, на семейства в пет страни.",
  cta_subtitle: "В ромската традиция никога не изоставяме възрастните си. Присъединете се към стотици семейства, пазещи това обещание из Европа. Първата консултация е безплатна.",
  footer_desc: "Вкоренени в ромските ценности на семейство и доброта — състрадателна домашна грижа из Балканите и Централна Европа.",
};

// ─── HUNGARIAN ───────────────────────────────────────────────────────────────

const hu_shared: TranslationKeys = {
  nav_services: "Szolgáltatások",
  nav_howItWorks: "Hogyan működik",
  nav_pricing: "Árak",
  nav_testimonials: "Vélemények",
  nav_getStarted: "Kezdés",

  hero_badge: "Megbízható otthoni gondoskodás 5 országban",
  hero_title: "A család mindent jelent. Úgy gondoskodunk a tiédről, mint a sajátunkról.",
  hero_subtitle: "Meleg, megbízható otthoni gondoskodás szüleidnek Szerbiában, Romániában, Macedóniában, Bulgáriában és Magyarországon, amíg te külföldön élsz.",
  hero_cta: "Kezdj el gondoskodni ma",
  hero_secondary: "Nézd meg, hogyan működik",
  hero_countries: "5 ország",
  hero_families: "500+ egyesített család",
  hero_caregivers: "Ellenőrzött gondozók",
  hero_book_service: "Szolgáltatás foglalása",

  services_label: "Mit csinálunk",
  services_title: "A közösség melege, közvetlenül az ajtajuknál",
  services_subtitle: "Gondozóink gyakorlati segítséget és őszinte jóságot hoznak, ami boldogan és önállóan tartja szüleidet otthon.",
  service_errands: "Ügyek és bevásárlás",
  service_errands_desc: "Bevásárlás, postai ügyintézés, számlák befizetése — minden napi teendő gondossággal intézve.",
  service_cooking: "Főzés és étkezés",
  service_cooking_desc: "Házi készítésű hagyományos ételek frissen elkészítve, az étrendi igények tiszteletben tartásával.",
  service_cleaning: "Takarítás",
  service_cleaning_desc: "Rendszeres háztartási munkák a tiszta, kényelmes és biztonságos otthonért.",
  service_walks: "Séták és társaság",
  service_walks_desc: "Napi séták, társas látogatások és tartalmas beszélgetések, hogy feldobják a napjukat.",
  service_pharmacy: "Gyógyszertár és egészség",
  service_pharmacy_desc: "Receptek kiváltása, gyógyszer-emlékeztetők és orvosi kíséret.",
  service_social: "Szociális támogatás",
  service_social_desc: "Segítség telefonálásban, technológiában és a családdal való kapcsolattartásban.",
  service_book_cta: "Foglald le ezt a szolgáltatást",

  how_label: "Hogyan működik",
  how_title: "Egyszerű lépések a családod megtiszteléséhez",
  how_subtitle: "A távolság nem szakíthatja el a köteléket. Percek alatt gondoskodó kezeket hozhatsz szüleid otthonába — telefonodról irányítva, bárhová is vitt az élet.",
  how_step1_title: "Mesélj a szüleidről",
  how_step1_desc: "Oszd meg a tartózkodási helyüket, igényeiket és preferenciáikat. Összepárosítjuk őket a megfelelő közeli gondozóval.",
  how_step2_title: "Válassz gondozási tervet",
  how_step2_desc: "Válassz rugalmas tervek közül — heti látogatások, napi ellenőrzések vagy egyedi ütemezés.",
  how_step3_title: "A gondoskodás elindul, te tájékozott maradsz",
  how_step3_desc: "Szüleid együttérző segítséget kapnak otthon. Rendszeres frissítéseket, fotókat és lelki nyugalmat kapsz.",

  pricing_label: "Árak",
  pricing_title: "Átlátható, megfizethető gondozási tervek",
  pricing_subtitle: "Nincsenek rejtett díjak. Bármikor lemondható. Minden terv ellenőrzött gondozókat tartalmaz.",
  pricing_mostPopular: "Legnépszerűbb",
  pricing_perMonth: "/hónap",
  pricing_getStarted: "Kezdés",
  pricing_essential: "Alap",
  pricing_essential_desc: "Könnyű támogatás önálló szülőknek",
  pricing_comfort: "Komfort",
  pricing_comfort_desc: "Átfogó napi gondoskodás és társaság",
  pricing_premium: "Prémium",
  pricing_premium_desc: "Teljes napi támogatás és elsőbbségi gondoskodás",
  pricing_feature_2visits: "Heti 2 látogatás",
  pricing_feature_errands: "Ügyek és bevásárlás",
  pricing_feature_housekeeping: "Alapvető háztartás",
  pricing_feature_weeklyPhotos: "Heti fotós frissítések",
  pricing_feature_phoneSupport: "Telefonos támogatás",
  pricing_feature_5visits: "Heti 5 látogatás",
  pricing_feature_allEssential: "Minden Alap szolgáltatás",
  pricing_feature_meals: "Házi főtt ételek",
  pricing_feature_pharmacy: "Gyógyszertári és egészségügyi támogatás",
  pricing_feature_dailyPhotos: "Napi frissítések fotókkal",
  pricing_feature_dedicatedCaregiver: "Dedikált gondozó",
  pricing_feature_dailyVisits: "Napi látogatások (7 nap)",
  pricing_feature_allComfort: "Minden Komfort szolgáltatás",
  pricing_feature_walks: "Társasági séták",
  pricing_feature_doctorVisit: "Orvosi kíséret",
  pricing_feature_realtime: "Valós idejű frissítések",
  pricing_feature_emergency: "24/7 sürgősségi vonal",
  pricing_feature_videoReport: "Havi videó jelentés",

  testimonials_label: "Vélemények",
  testimonials_title: "Családunk egyre nő",

  story_label: "Történetünk",
  story_title: "Azok építették, akik először gondoskodnak",
  story_p1: "A Vita Dom valami személyesből született. Alapítóink — Európa-szerte élő szakemberek — minden nap ugyanazzal a csendes aggodalommal szembesültek: ki vigyáz a szüleinkre otthon?",
  story_p2: "Számunkra az idősek elhagyása elképzelhetetlen. A család mindennek az alapja. Ahelyett, hogy elfogadták volna a távolságot, alapítóink elkezdték megszervezni saját szüleik gondozását — főzés, ügyek, társaság, gyógyszertári utak — megbízható helyi segítőkön keresztül.",
  story_p3: "Ami családi gyakorlatként indult, gyorsan küldetéssé vált. A Vita Dom azért jött létre, hogy ezt a gondoskodást minden családra kiterjessze — mert egyetlen szülőnek sem kellene elfelejtettnek éreznie magát.",
  story_card1_title: "A család az első, mindig",
  story_card1_desc: "Minden döntésünk egy kérdéssel kezdődik: elég jó lenne ez a saját szüleinknek?",
  story_card2_title: "Közösségi értékek, európai elérés",
  story_card2_desc: "Közösségben gyökerező jóságot viszünk öt ország családjaihoz.",
  story_card3_title: "A személyestől az egyetemesig",
  story_card3_desc: "Ami azzal kezdődött, hogy az alapítók saját szüleikről gondoskodtak, ma minden diaszpóra család számára elérhető szolgáltatás.",

  cta_title: "Szüleid mindent megadtak neked. Most adj vissza.",
  cta_subtitle: "Soha nem hagyjuk el időseinket. Csatlakozz a több száz családhoz, akik Európa-szerte tartják ezt az ígéretet. Az első konzultáció ingyenes.",
  cta_primary: "Ingyenes konzultáció",
  cta_secondary: "Hívj minket",

  footer_desc: "Együttérző otthoni gondoskodás a Balkánon és Közép-Európában — családi értékekben és jóságban gyökerezve.",
  footer_services: "Szolgáltatások",
  footer_countries: "Országok",
  footer_contact: "Kapcsolat",
  footer_rights: "Vita Dom. Minden jog fenntartva.",

  order_title: "Rendelje meg a gondozási tervet",
  order_subtitle: "Válasszon tervet, adja meg adatait, és küldje el kérését. Egy kollégánk 1–2 munkanapon belül felveszi Önnel a kapcsolatot.",
  order_select_plan: "Válassza ki a tervet",
  order_reserve_cta: "Foglalás kérése",
  order_reserve_note: "Foglalja le a helyét — most fizetés nélkül. 1–2 munkanapon belül felhívjuk a regisztráció befejezéséhez.",
  order_contact_cta: "Kapcsolat",
  order_back: "Vissza a főoldalra",
  order_success_title: "Foglalás megerősítve!",
  order_success_desc: "Köszönjük! Foglalási kérését megkaptuk. 1–2 munkanapon belül felvesszük Önnel a kapcsolatot.",
  order_processing: "Feldolgozás...",
  order_your_details: "Az Ön adatai",
  order_name: "Teljes név",
  order_name_placeholder: "pl. Kovács Mária",
  order_email: "E-mail",
  order_email_placeholder: "az@emailje.com",
  order_phone: "Telefon (opcionális)",
  order_phone_placeholder: "+36 30 123 4567",
  order_fill_fields: "Kérjük, töltse ki a nevét és e-mail címét.",
  order_interest_cta: "Foglalási kérelem elküldése",
  order_interest_note: "Most nem szükséges fizetés. 1–2 munkanapon belül felvesszük Önnel a kapcsolatot a gondozási terv megbeszéléséhez.",
  order_interest_success: "Köszönjük az érdeklődést!",
  order_interest_success_desc: "Kollégánk 1–2 munkanapon belül felveszi Önnel a kapcsolatot.",
  order_message: "Üzenet (opcionális)",
  order_message_placeholder: "Kérdések vagy részletek, amelyeket meg szeretne osztani...",
  order_sending: "Küldés...",

  dynamic_not_found: "Az oldal nem található",

  faq_title: "Gyakran ismételt kérdések",
  faq_q1: "Milyen szolgáltatásokat kínálnak?",
  faq_a1: "Átfogó otthoni gondozási szolgáltatásokat kínálunk, beleértve az ügyek és bevásárlás intézését, főzést és étkezést, takarítást, sétákat és társaságot, gyógyszertári és egészségügyi támogatást, valamint szociális támogatást. Minden szolgáltatást ellenőrzött, helyi gondozók nyújtanak.",
  faq_q2: "Hogyan működik a foglalási folyamat?",
  faq_a2: "Egyszerűen válasszon egy gondozási tervet, amely megfelel családja igényeinek, töltse ki adatait, és vagy fizesse be a €10 foglalási díjat, vagy fejezze ki érdeklődését. Egy kollégánk 1–2 munkanapon belül felveszi Önnel a kapcsolatot a részletek véglegesítéséhez és egy gondozó kijelöléséhez.",
  faq_q3: "Mit jelent a €10 foglalási díj?",
  faq_a3: "A €10 díj biztosítja a helyét és elköteleződést mutat. Az első havi fizetésből levonásra kerül. Ha nem tudunk szolgáltatást nyújtani az Ön területén, a díjat teljes egészében visszatérítjük.",
  faq_q4: "Lemondhatom az előfizetésemet?",
  faq_a4: "Igen, bármikor lemondhat büntetés nélkül. Hiszünk abban, hogy minden hónapban ki kell érdemelnünk a bizalmát. Egyszerűen lépjen kapcsolatba velünk, és azonnal feldolgozzuk a lemondást.",
  faq_q5: "Milyen területeket szolgálnak ki?",
  faq_a5: "Jelenleg öt országban működünk: Szerbia, Románia, Észak-Macedónia, Bulgária és Magyarország. Folyamatosan terjeszkedünk új városokba és régiókba ezekben az országokban.",
  faq_q6: "Hogyan választják ki a gondozókat?",
  faq_a6: "Minden gondozó alapos ellenőrzési folyamaton megy keresztül, beleértve a háttérellenőrzést, a referenciák ellenőrzését és a személyes interjúkat. Olyan embereket választunk, akik nemcsak képzettek, hanem valóban együttérzőek és megbízhatóak.",
  faq_q7: "Milyen nyelveken beszélnek a gondozóik?",
  faq_a7: "Gondozóink az adott ország helyi nyelvét beszélik. Sokan beszélnek angolul vagy más regionális nyelven is. Amikor csak lehetséges, a nyelvi preferenciák alapján párosítjuk a gondozókat a családokkal.",
  faq_q8: "Hogyan léphetnek kapcsolatba Önökkel?",
  faq_a8: "Elérhet minket e-mailben az office@vita-dom.org címen vagy telefonon. Látogassa meg a kapcsolat szekciónkat a teljes részletekért. Általában egy munkanapon belül válaszolunk.",
};

const hu_roma: Partial<TranslationKeys> = {
  hero_badge: "A roma családi odaadás hagyományából született",
  hero_subtitle: "A roma jóság és közösség szellemében gyökerezve — meleg, megbízható otthoni gondoskodás szüleidnek Szerbiában, Romániában, Macedóniában, Bulgáriában és Magyarországon, amíg te külföldön élsz.",
  services_subtitle: "Mint egy jó szomszéd a mahaláról — gondozóink gyakorlati segítséget és őszinte jóságot hoznak, ami boldogan és önállóan tartja szüleidet otthon.",
  story_p1: "A Vita Dom valami személyesből született. Alapító tagjaink — Európa-szerte élő roma szakemberek — minden nap ugyanazzal a csendes aggodalommal szembesültek: ki vigyáz a szüleinkre otthon?",
  story_p2: "A roma kultúrában az idősek elhagyása elképzelhetetlen. A család mindennek az alapja. Ahelyett, hogy elfogadták volna a távolságot, alapítóink elkezdték megszervezni saját szüleik gondozását — főzés, ügyek, társaság, gyógyszertári utak — megbízható helyi segítőkön keresztül.",
  story_p3: "Ami családi gyakorlatként indult, gyorsan küldetéssé vált. A Roma Foundations for Europe, egy elismert európai alapítvány révén a Vita Dom azért jött létre, hogy ezt a gondoskodást minden családra kiterjessze — mert egyetlen szülőnek sem kellene elfelejtettnek éreznie magát.",
  story_card2_title: "Roma értékek, európai elérés",
  story_card2_desc: "A Roma Foundations for Europe támogatásával közösségben gyökerező jóságot viszünk öt ország családjaihoz.",
  cta_subtitle: "A roma hagyományban soha nem hagyjuk el időseinket. Csatlakozz a több száz családhoz, akik Európa-szerte tartják ezt az ígéretet. Az első konzultáció ingyenes.",
  footer_desc: "A roma család és jóság értékeiben gyökerezve — együttérző otthoni gondoskodás a Balkánon és Közép-Európában.",
};

// ─── EXPORT ─────────────────────────────────────────────────────────────────

const allTranslations: Record<Language, VariantTranslations> = {
  en: { universal: en_shared, roma: { ...en_shared, ...en_roma } },
  ro: { universal: ro_shared, roma: { ...ro_shared, ...ro_roma } },
  sr: { universal: sr_shared, roma: { ...sr_shared, ...sr_roma } },
  mk: { universal: mk_shared, roma: { ...mk_shared, ...mk_roma } },
  bg: { universal: bg_shared, roma: { ...bg_shared, ...bg_roma } },
  hu: { universal: hu_shared, roma: { ...hu_shared, ...hu_roma } },
};

export function getTranslations(lang: Language, variant: StoryVariant): TranslationKeys {
  const base = allTranslations[lang][variant];
  if (lang === "en" || lang === "ro") return base;
  return { ...base, ...orderInquiryStrings };
}

export const translations = allTranslations;
